export default "__VITE_ASSET__894fafd6__"